import { h, Fragment, ComponentChildren } from "preact"; /** @jsx h */

import { type ICourse, type IWiki } from "@pyqml/model";
import { ROUTES } from '@pyqml/shared';

import { Layout } from './Layout';
import { List } from './List';

import { Content } from "./Content";
import { ContentItem } from "./ContentItem";
import { BlogCover } from "./BlogCover";

import { useEnvironment } from "../app/Environment";

export type IPyQMLTeaserProps = {
    //content: string;
    //featuredItems: Array<IPyQMLItem>,
    pyqmlWiki: IWiki;
    teaserCourses: Array<ICourse>;
};

export type IPyQMLItem = {
    title: string;
    abstract: string;
    image: string;
    linkTo: string;
};

const ItemList = ({ items }: { items: IPyQMLItem[] }) => (
    
    <List.Promoted>
        {
            items.map((item: IPyQMLItem) => (
                <List.Item
                    title={item.title}
                    abstract={item.abstract}
                    image={item.image}
                    linkTo={item.linkTo}
                >
                    { !item.image && <BlogCover title={item.title} subtitle="" compact={true}/> }
                </List.Item>
            ))
        }
    </List.Promoted>
);


export const PyQMLTeaser = (props: IPyQMLTeaserProps) => {

    const { baseUrl, imageUrl } = useEnvironment();


    const { firstColumn, secondColumn, lastColumn } = (function() {
        
        if (!props.teaserCourses) {
            return {
                firstColumn: [],
                secondColumn: [],
                lastColumn: []
            };
        }
        const courses = props.teaserCourses.map((course: ICourse) => ({
            title: course.title,
            abstract: course.abstract,
            image: course.abstractImage ? `${imageUrl}/${course.abstractImage}` : undefined,
            linkTo: `${baseUrl}${ROUTES.BLOG_TEASERCOURSE}/${course.slug}`,
        })) ?? [];

        const firstColumn: IPyQMLItem[] = [];
        const secondColumn: IPyQMLItem[] = [];
        const lastColumn: IPyQMLItem[] = [];

        courses.forEach((course, index) => {
            if (index % 3 === 0) {
                firstColumn.push(course);
            } else if (index % 3 === 1) {
                secondColumn.push(course);
            } else {
                lastColumn.push(course);
            }
        });
    
        return { firstColumn, secondColumn, lastColumn };
        
    })();

    //console.log(props, firstColumn, secondColumn, lastColumn);

    return props.pyqmlWiki && (
        <Layout.Section weight="equal">
            
            <Content >
                <ContentItem contentId={"contentElement"} text={props.pyqmlWiki?.content ?? ""} paywalled={""} />
            </Content>
            
            <Layout.Column><ItemList items={firstColumn} /></Layout.Column>
            <Layout.Column><ItemList items={secondColumn} /></Layout.Column>
            <Layout.Column><ItemList items={lastColumn} /></Layout.Column>
            
        </Layout.Section>

    ) || <Fragment></Fragment>;
}
